<template>
  <section>
    <div class="search-content">
      <el-row :gutter="20">
        <el-col :span="14">
          <el-button class="search-btn" size="small" type="main" icon="el-icon-plus" @click="handleAdd">新增</el-button>
          <el-button class="search-btn" size="small" type="search" icon="el-icon-search" @click="handleSearchDialog">筛选</el-button>
          <el-button class="search-btn" size="small" type="danger" icon="el-icon-delete-solid" @click="handleBatchDelete">删除</el-button>
          <el-button class="search-btn" size="small" type="success" icon="el-icon-upload2" @click="handleExport">导出</el-button>
        </el-col>
        <el-col :span="10" style="text-align: right;">
          <el-input class="search-input" size="small" placeholder="请输入姓名" v-model="searchInfo.name"></el-input>
          <el-button class="search-btn" size="small" type="main" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="table-content">
      <el-table
        :data="tableData"
        v-loading="loading"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%;margin-top:20px">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名称"
          width="180">
        </el-table-column>
        <el-table-column
          prop="account"
          label="账号">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          width="180">
        </el-table-column>
        <el-table-column
          prop="role"
          label="角色"
          width="100"
          :formatter="roleFormatter">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          width="200">
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="main" size="mini" icon="el-icon-edit-outline" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" icon="el-icon-delete-solid" @click="handleDel(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="table-page"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total">
      </el-pagination>
    </div>
    <el-dialog title="用户信息" width="75%" :visible.sync="contentDialogVisible" :close-on-click-modal="false">
      <el-form label-position="right" :rules="userInfoRules" :ref="formRef" :model="contentInfo" label-width="130px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称：" prop="name">
              <el-input v-model="contentInfo.name" maxlength="50"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：" prop="phone">
              <el-input v-model="contentInfo.phone" maxlength="20"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账号：" prop="account">
              <el-input maxlength="20" v-model="contentInfo.account"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码：" prop="password">
              <el-button type="primary" size="small" v-if="isEditMode" @click="resetPassword">重置密码</el-button>
              <el-input v-else type="password" maxlength="50" v-model="contentInfo.password"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="角色：" prop="role">
              <el-select v-model="contentInfo.role" placeholder="请选择" style="width:100%">
                <el-option
                  v-for="item in roleList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="机构/企业：" prop="organization" :rules="contentInfo.role!=='admin'?userInfoRules.organization:[{required: false}]">
              <el-autocomplete style="width: 100%" v-model="contentInfo.organization" :fetch-suggestions="queryOrgAsync" @select="handleOrgSelect"></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="机构/企业代码：" prop="organizationCode">
              <el-input v-model="contentInfo.organizationCode"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="contentInfo.role === 'enterprise'">
          <el-col :span="12">
            <el-form-item label="法人代表：" prop="legalPerson">
              <el-input v-model="contentInfo.legalPerson"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="法人联系电话：" prop="legalPersonPhone">
              <el-input v-model="contentInfo.legalPersonPhone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="contentInfo.role === 'enterprise'">
          <el-col :span="12">
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="contentInfo.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="从业人员：" prop="employee">
              <el-input v-model="contentInfo.employee"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="contentInfo.role === 'enterprise'">
          <el-col :span="12">
            <el-form-item label="企业规模：" prop="enterpriseSize">
              <el-select v-model="contentInfo.enterpriseSize" placeholder="请选择" style="width:100%">
                <el-option
                  v-for="item in enterpriseSizeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业性质：" prop="enterpriseType">
              <el-select v-model="contentInfo.enterpriseType" placeholder="请选择" style="width:100%">
                <el-option
                  v-for="item in enterpriseTypeList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="contentInfo.role === 'enterprise'">
          <el-col :span="12">
            <el-form-item label="注册资本：" prop="registerMoney">
              <el-input v-model="contentInfo.registerMoney"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册时间：" prop="registerTime">
              <el-date-picker
                style="width: 100%;"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="contentInfo.registerTime">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="contentInfo.role === 'enterprise'">
          <el-col :span="12">
            <el-form-item label="注册地址：" prop="registerAddress">
              <el-select
                style="width: 100%"
                v-model="contentInfo.registerAddress"
                filterable
                placeholder="请输入地区/园区">
                <el-option
                  v-for="item in parkList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册详细地址：" prop="registerDetailAddress">
              <el-input v-model="contentInfo.registerDetailAddress"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="contentInfo.role === 'enterprise'">
          <el-col :span="12">
            <el-form-item label="企业所在地：" prop="locationArea">
              <el-select
                style="width: 100%"
                v-model="contentInfo.locationArea"
                filterable
                placeholder="请输入地区/园区">
                <el-option
                  v-for="item in parkList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在地详细地址：" prop="address">
              <el-input v-model="contentInfo.address"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" v-if="contentInfo.role === 'enterprise'">
          <el-col :span="12">
            <el-form-item label="营业执照：" prop="licenseUrl">
              <!--<el-upload-->
                <!--class="upload-demo"-->
                <!--action="/appeal/file/upload/userLicense"-->
                <!--:on-success="handleLicenseSuccess"-->
                <!--:on-remove="handleLicenseRemove"-->
                <!--multiple-->
                <!--:file-list="licenseFileList">-->
                <!--<el-button icon="el-icon-upload" type="main">点击上传</el-button>-->
              <!--</el-upload>-->
              <div v-for="file in licenseFileList">
                <el-link :underline="false" type="info" :href="file.response.data" target="_blank">{{file.name}}</el-link>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="真实承诺书：" prop="commitmentUrl">
              <!--<el-upload-->
                <!--class="upload-demo"-->
                <!--action="/appeal/file/upload/userCommitment"-->
                <!--:on-success="handleCommitmentSuccess"-->
                <!--:on-remove="handleCommitmentRemove"-->
                <!--multiple-->
                <!--:file-list="commitmentFileList">-->
                <!--<el-button icon="el-icon-upload" type="main">点击上传</el-button>-->
              <!--</el-upload>-->
              <div v-for="file in commitmentFileList">
                <el-link :underline="false" type="info" :href="file.response.data" target="_blank">{{file.name}}</el-link>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="contentDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog title="重置密码" :visible.sync="passInfoVisible" :close-on-click-modal="false">
      <el-form :model="passInfo" ref="passForm" :rules="rules">
        <el-form-item label="新密码" type="password" label-width="80px" prop="newPass">
          <el-input type="password" v-model="passInfo.newPass"></el-input>
        </el-form-item>
        <el-form-item label="确认密码" type="password" label-width="80px" prop="confrmPass">
          <el-input type="password" v-model="passInfo.confrmPass"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passInfoVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveNewPass">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="筛选" width="75%" :visible.sync="searchDialogVisible" :close-on-click-modal="false">
      <el-form :model="searchInfo" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="名称：">
              <el-input v-model="searchInfo.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号：">
              <el-input v-model="searchInfo.phone"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="账号：">
              <el-input v-model="searchInfo.account"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="角色：">
              <el-select v-model="searchInfo.role" placeholder="请选择" style="width:100%" clearable>
                <el-option
                  v-for="item in roleList"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="searchDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSearch">搜 索</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import md5 from 'js-md5'
  import Common from '@/components/common/Common'
  import { Table } from '@/components/common/Table'
  import { listUser, addUser, updateUser, detailUser, deleteUser, allRole, resetUserPwd, batchDeleteUser, listOrg, userExport, portalDictionary,portalParkList } from '@/api/restapi.js'
  export default {
    mixins: [Table],
    data() {
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'))
        } else if (value !== this.passInfo.newPass) {
          callback(new Error('两次输入密码不一致!'))
        } else {
          callback()
        }
      }
      return {
        user: Common.user,
        roleList: [],
        parkList: [],
        passInfoVisible: false,
        isEditMode: false,
        enterpriseSizeList: [],
        enterpriseTypeList: [],
        commitmentFileList: [],
        licenseFileList: [],
        rules: {
          newPass: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
          confrmPass: [
            { required: true, validator: validatePass2, trigger: 'blur' }
          ]
        },
        userInfoRules: {
          name: [
            { required: true, message: '请填写姓名', trigger: 'blur' }
          ],
          account: [
            { required: true, message: '请填写账号', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请填写密码', trigger: 'blur' }
          ],
          role: [
            { required: true, message: '请选择角色', trigger: 'change' }
          ],
          phone: [
            { required: true, message: '请填写手机号', trigger: 'blur' }
          ],
          organization: [
            { required: true, message: '请填写企业/机构', trigger: 'blur' }
          ]
        },
        passInfo: {}
      }
    },
    mounted () {
      portalDictionary('enterprise_size').then(res => {
        if (res.data.code === 0) {
          this.enterpriseSizeList = res.data.data
        }
      })
      portalDictionary('enterprise_type').then(res => {
        if (res.data.code === 0) {
          this.enterpriseTypeList = res.data.data
        }
      })
      allRole().then(res => {
        if (res.data.code === 0) {
          this.roleList = res.data.data
        }
      })
      this.queryParkAsync('')
    },
    methods: {
      queryParkAsync (queryString, cb) {
        portalParkList(queryString).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                id: o.id
              })
            })
            this.parkList = names
          }
        })
      },
      handleLicenseSuccess (res,file) {
        this.contentInfo.licenseUrl.push({
          fileName: file.name,
          fileUrl: file.response.data
        })
      },
      handleLicenseRemove (res, file) {
        let att = []
        file.forEach(f => {
          att.push({
            fileName: f.name,
            fileUrl: f.response.data
          })
        })
        this.contentInfo.licenseUrl = att
      },
      handleCommitmentSuccess (res,file) {
        this.contentInfo.commitmentUrl.push({
          fileName: file.name,
          fileUrl: file.response.data
        })
      },
      handleCommitmentRemove (res, file) {
        let att = []
        file.forEach(f => {
          att.push({
            fileName: f.name,
            fileUrl: f.response.data
          })
        })
        this.contentInfo.commitmentUrl = att
      },
      searchMethod () {
        return listUser(this.pageInfo.page,this.pageInfo.size, this.searchInfo)
      },
      beforeAdd () {
        this.isEditMode = false
        this.contentInfo = {
          name: '',
          account: '',
          password: '',
          role: this.roleList[0].code,
          phone: '',
          enterpriseSize: '',
          address: ''
        }
      },
      addMethod () {
        this.contentInfo.password = md5(this.contentInfo.password)
        if (this.contentInfo.role !== 'enterprise') {
          this.contentInfo.enterpriseSize = ''
          this.contentInfo.address = ''
        }
        return addUser(this.contentInfo)
      },
      beforeUpdate () {
        this.isEditMode = true
        if (this.contentInfo.role === 'enterprise') {
          detailUser(this.contentInfo.id).then(res => {
            if (res.data.code === 0){
              let organization = this.contentInfo.organization
              this.contentInfo = Object.assign({},res.data.data)
              this.contentInfo.organization = organization
              if (this.contentInfo.locationArea) {
                this.contentInfo.locationArea = parseInt(this.contentInfo.locationArea)
              }
              if (this.contentInfo.registerAddress) {
                this.contentInfo.registerAddress = parseInt(this.contentInfo.registerAddress)
              }
              this.commitmentFileList = []
              if (this.contentInfo.commitmentUrl) {
                this.contentInfo.commitmentUrl.forEach(file => {
                  this.commitmentFileList.push({
                    name: file.fileName,
                    response: {
                      data: file.fileUrl
                    }
                  })
                })
              }
              this.licenseFileList = []
              if (this.contentInfo.licenseUrl) {
                this.contentInfo.licenseUrl.forEach(file => {
                  this.licenseFileList.push({
                    name: file.fileName,
                    response: {
                      data: file.fileUrl
                    }
                  })
                })
              }
            }
          })

        }
      },
      updateMethod () {
        this.contentInfo.password = ''
        if (this.contentInfo.role !== 'enterprise') {
          this.contentInfo.enterpriseSize = ''
          this.contentInfo.address = ''
        }
        return updateUser(this.contentInfo)
      },
      deleteMethod (id) {
        return deleteUser(id)
      },
      batchDeleteMethod () {
        return batchDeleteUser(this.selectIds)
      },
      queryOrgAsync (queryString, cb) {
        listOrg(1,999,{
          name: queryString
        }).then(res => {
          if (res.data.code === 0) {
            let names = []
            res.data.data.list.forEach(o => {
              names.push({
                value: o.name,
                code: o.code,
                id: o.id
              })
            })
            cb(names)
          }
        })
      },
      handleExport () {
        userExport(this.searchInfo).then(res => {
          const blob = new Blob([res.data])
          const fileName = '用户列表.xlsx'
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        })
      },
      handleOrgSelect (item) {
        this.contentInfo.organizationCode = item.code
        this.contentInfo.organizationId = item.id
      },
      resetPassword () {
        this.passInfo = {}
        this.passInfoVisible = true
      },
      saveNewPass () {
        let isValid = true
        this.$refs['passForm'].validate((valid) => {
          if (!valid) {
            isValid = false
          }
        })
        if (!isValid) {
          return
        }
        resetUserPwd(this.contentInfo.id, md5(this.passInfo.newPass)).then(res => {
          if (res.data.code === 0) {
            this.passInfoVisible = false
            this.$message({
              showClose: true,
              message: '重置成功',
              type: 'success'
            })
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error'
            })
          }
        }).catch(err => {
          this.$message({
            showClose: true,
            message: '密码修改失败',
            type: 'error'
          })
          console.log(err)
        })
      },
      roleFormatter (row, col) {
        let name = ''
        this.roleList.forEach(r => {
          if (row.role === r.code) {
            name = r.name
          }
        })
        return name
      }
    }
  }
</script>
<style scoped>
  @import "../style/Table.css";
</style>



// WEBPACK FOOTER //
// src/components/User.vue